import { useMutation, useQueryClient, } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getFeedKey, getPostsKey, getSpaceKey } from '../../utils/keys';
import { useAuthMember } from '../auth/useAuthMember';
import { addPostToPaginatedPost } from '../cache/useCachedPost';
import { infiniteSpaceUpdater, spacePostsUpdater, } from '../cache/useCachedSpace';
import { getSpacesQueryById } from '../spaces/filters';
const spacePostsKey = (spaceId) => ({
    active: true,
    predicate: query => {
        var _a, _b, _c;
        const [main, args] = query.queryKey || [];
        return (main === getFeedKey()[0] ||
            (main === getPostsKey()[0] &&
                ((_c = (_b = (_a = args) === null || _a === void 0 ? void 0 : _a.variables) === null || _b === void 0 ? void 0 : _b.spaceIds) === null || _c === void 0 ? void 0 : _c.indexOf(spaceId)) > -1));
    },
});
const onAddPost = (variables, newPost, queryClient) => {
    var _a;
    const { spaceId } = variables;
    /** Add the post to the feed and posts queries */
    queryClient.setQueriesData(spacePostsKey(spaceId), addPostToPaginatedPost(newPost));
    /**  Add the post to Space.posts in any spaces queries where the parent space exists */
    const spacesQueryFilter = getSpacesQueryById(spaceId);
    // update posts within the found space everywhere (spaces and the feed queries)
    queryClient.setQueriesData(spacesQueryFilter, infiniteSpaceUpdater(spaceId, spacePostsUpdater(newPost)));
    /**  space.authMemberProps contains update lastReadAt field */
    if ((_a = newPost === null || newPost === void 0 ? void 0 : newPost.space) === null || _a === void 0 ? void 0 : _a.authMemberProps) {
        const spaceKey = getSpaceKey({ variables: { id: spaceId } });
        const spaceUpdater = (old) => {
            var _a;
            if (!old) {
                return;
            }
            return {
                ...old,
                authMemberProps: {
                    ...old === null || old === void 0 ? void 0 : old.authMemberProps,
                    ...(_a = newPost === null || newPost === void 0 ? void 0 : newPost.space) === null || _a === void 0 ? void 0 : _a.authMemberProps,
                },
            };
        };
        queryClient.setQueriesData(spaceKey, spaceUpdater);
    }
};
export const useAddPost = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const { data: authMember } = useAuthMember();
    return useMutation((input) => client.posts.create(input, fields), {
        onSuccess: (data, variables) => {
            onAddPost(variables, data, queryClient);
        },
        onSettled: (data, error, variables) => {
            queryClient.invalidateQueries(spacePostsKey(variables.spaceId));
            const spaceKey = getSpaceKey({ variables: { id: variables.spaceId } });
            queryClient.invalidateQueries(spaceKey);
            queryClient.invalidateQueries(getPostsKey({ variables: { memberId: authMember.id } }));
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useAddPost.js.map